<template>
  <div class="container">
    <b-card header-tag="header">
      <template #header>
        <b-row align-h="between" align-v="center">
          <h4 class="card-tittle">Detalle de Boleta/Factura</h4>
          <b-button variant="dark" @click="back()">Volver </b-button>
        </b-row>
      </template>

      <div v-if="isBusy" class="text-center text-danger space">
        <b-spinner class="align-middle"></b-spinner>
      </div>
      
      <template v-if="!isBusy">

        <b-row align-h="between" align-v="center" class="contentRow">
          <template v-if="data">

            <!-- INICIO PRIMERA ROW -->
            <b-row align-h="between" align-v="center" class="mainRow">
              <b-col cols="4" class="redCol alto150"> DATOS DEL DOCUMENTO </b-col>
              <b-col cols="8">
                <p>
                  Tipo de documento:
                  <b>{{
                    data.descDocumento ? data.descDocumento : " No especificado"
                  }}</b>
                </p>            
                <p>
                  Número:
                  <b>{{
                    data.numeroDocumento ? data.numeroDocumento : "No especificado"
                  }}</b>
                </p>
                <p>
                  Fecha de Emisión:
                  <b>{{
                    data.fechaEmision ? formatFecha(data.fechaEmision) : "No especificada"
                  }}</b>
                </p>
                <p>
                  Nombre:
                  <b>{{
                    data.nombre ? data.nombre : "No especificado"
                  }}</b>
                </p>
              </b-col>
            </b-row>
            
            <!-- Inicio Tabla -->
            <b-row v-if="!isBusy" align-h="between" align-v="center" class="mainRow">
              <div class="table-responsive mb-0 mt-5">
                <b-table
                  thead-tr-class="titleTable"
                  :items="data.detalle"
                  :fields="fields"
                  responsive="sm"
                  :striped="true"
                  :bordered="true"
                >
                  <!-- Inicio Spinner en estado "ocupado" de la tabla 1 -->
                  <template #table-busy>
                    <div class="text-center text-danger my-2">
                      <b-spinner class="align-middle"></b-spinner>
                    </div>
                  </template>
                  <!-- Fin Spinner en estado "ocupado" de la tabla 1 -->

                  <template slot="bottom-row" slot-scope="">                    
                    <td />
                    <td>Total</td>
                    <td>
                      {{
                        data.total ? "$" + getCurrency(data.total) : "No especificado"
                      }}
                    </td>
                  </template>

                  <template #cell(totalAfecto)="row">
                    {{ "$" + getCurrency(row.value) }}
                  </template>
                  <template #cell(totalExento)="row">
                    {{ "$" + getCurrency(row.value) }}
                  </template>

                </b-table>
              </div>
            </b-row>
            <!-- Fin Tabla -->

          </template>
          <template v-else>
            <h3 class="text-center">No se encontró la factura/boleta</h3>
          </template>
        </b-row>

      </template>
      
    </b-card>
    </div>
</template>

<script>
import axios from "@/axios";
import moment from "moment";
import { formatCurrency } from "@/utils";
export default {
  data() {
    return {
      data: [],
      fields: [
        {
          key: "concepto",
          label: "Concepto",
          sortable: false,
        },
        {
          key: "totalExento",
          label: "Total Exento",
          sortable: false,
        },
        {
          key: "totalAfecto",
          label: "Total Afecto",
          sortable: false,
        },
      ],
      isBusy: false,
      estado: ""
    };
  },
  beforeMount() {
    this.getDetail();
  },
  computed:{
    classEstado(){
      if (this.estado == "APROBADO"){
        return "pass"
      }else{
        return "nopass"
      }
    }
  },
  methods: {
    getCurrency(inport) {
      return formatCurrency(inport);
    },
    getDetail() {
      this.isBusy = true;
      let data = {
        Numero: this.$store.getters["hideValue/detailId"],
        Tipo: this.$route.query.T,
        Rut: this.$store.getters["rutEmpresa/cuentaSeleccionada"].value
      }
      axios
        .get(`GetBoletaFacturaByNumero`, { params: { 
          Numero: data.Numero,
          Tipo: data.Tipo,
          Rut: data.Rut
          } })
        .then((detalle) => {          
          detalle.data.detalle.push({
            concepto: "Sub Totales",
            totalAfecto: detalle.data.totalAfecto,
            totalExento: detalle.data.totalExento
          });
          detalle.data.detalle.push({
            concepto: "Impuestos",
            totalAfecto: detalle.data.totalImpuesto,
            totalExento: ""
          });
          this.data = detalle.data;
          this.isBusy = false;
        })
        .catch(() => {
          this.$bvToast.toast(
            this.$t("lease.request.error.message").toString(),
            {
              title: this.$t("lease.request.error.nonFound").toString(),
              variant: "danger",
              solid: true,
            }
          );
          this.isBusy = false;
        });
    },
    formatFecha(fecha){
      return moment(fecha).format("DD-MM-YYYY")
    },
    back() {
      history.back();
    },
  },
};
</script>

<style scoped>
.card{
  width: 60% !important;
  margin-left: 20% !important;
  margin-top: 24px;
}
.mainRow {
  width: 100%;
  padding-left: 1em;
  padding-bottom: 0.2em;
}
.redCol {
  background-color: #e2231a;
  color: white;
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  justify-items: center;
  font-size: 0.8125rem;
  font: 200;
  text-align: center;
}
.redRow {
  background-color: #e2231a;
  color: white;
  padding-left: 1em;
  margin-bottom: 3em;
}
.card-tittle {
  font-size: 1.5rem;
  padding: 1rem;
  color: white;
}
.colImg {
  text-align: center;
}
.card-header {
  background-color: #e2231a;
}
img{
  height: 200px;
}
.alto150{
  height: 150px !important;
}
.pass{
  color: #fff;
  background-color: #28a745;
  border-color: #28a745;
}
.nopass{
  color: #fff;
  background-color: #dc3545;
  border-color: #dc3545;
}
</style>
